<template>
  <div class="attendance-clock-record-page">
    <PageHeaderLayout>
      <div class="main-page-content">
        <AttendanceTabs
          :tabs="attendanceTabs"
          :active-key="currentTabKey"
          @change="handleTabChange"
        />
        <keep-alive>
          <component :is="currentTabComponent" ref="currentTabPanel" />
        </keep-alive>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import AttendanceTabs from "./components/AttendanceTabs";
import AttendanceClockRecordList from "./components/AttendanceClockRecordList";
import AttendanceWorkStatsPanel from "./components/AttendanceWorkStatsPanel";
import AttendanceAbnormalPanel from "./components/AttendanceAbnormalPanel";

const PAGE_STATE_KEY = "attendance_clock_record_page_state";
const RECORD_LIST_STATE_KEY = "attendance_clock_record_list_state";
const ABNORMAL_PANEL_STATE_KEY = "attendance_abnormal_panel_state";
const RECORD_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_record_list";
const ABNORMAL_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_abnormal_list";
const STATS_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_stats_list";
const PRESERVE_PAGE_STATE_KEY = "attendance_clock_record_preserve_state_on_back";
const DEFAULT_TAB_KEY = "record";
const TAB_ITEMS = [
  { label: "打卡记录", key: DEFAULT_TAB_KEY },
  { label: "工时统计", key: "stats" },
  { label: "异常考勤", key: "abnormal" },
];
const TAB_COMPONENT_MAP = {
  [DEFAULT_TAB_KEY]: "AttendanceClockRecordList",
  stats: "AttendanceWorkStatsPanel",
  abnormal: "AttendanceAbnormalPanel",
};
const PAGE_CACHE_KEYS = [
  PAGE_STATE_KEY,
  RECORD_LIST_STATE_KEY,
  ABNORMAL_PANEL_STATE_KEY,
  RECORD_LIST_REFRESH_FLAG_KEY,
  ABNORMAL_LIST_REFRESH_FLAG_KEY,
  STATS_LIST_REFRESH_FLAG_KEY,
];

export default {
  name: "AttendanceClockRecord",
  components: {
    PageHeaderLayout,
    AttendanceTabs,
    AttendanceClockRecordList,
    AttendanceWorkStatsPanel,
    AttendanceAbnormalPanel,
  },
  computed: {
    currentTab() {
      return this.attendanceTabs[this.attendanceTabIndex] || this.attendanceTabs[0];
    },
    currentTabKey() {
      return this.currentTab ? this.currentTab.key : DEFAULT_TAB_KEY;
    },
    currentTabComponent() {
      return TAB_COMPONENT_MAP[this.currentTabKey];
    },
  },
  data() {
    return {
      attendanceTabIndex: 0,
      visitedTabKeys: [],
      attendanceTabs: TAB_ITEMS,
    };
  },
  created() {
    this.handlePageEnter();
    this.markTabVisited(this.currentTabKey);
  },
  beforeDestroy() {
    this.savePageState();
  },
  methods: {
    handlePageEnter() {
      if (this.consumePreservePageStateFlag()) {
        this.restorePageState();
        return;
      }
      this.clearPageStateCache();
    },
    consumePreservePageStateFlag() {
      const flag = window.sessionStorage.getItem(PRESERVE_PAGE_STATE_KEY);
      if (flag === "1") {
        window.sessionStorage.removeItem(PRESERVE_PAGE_STATE_KEY);
        return true;
      }
      return false;
    },
    clearPageStateCache() {
      this.attendanceTabIndex = 0;
      PAGE_CACHE_KEYS.forEach((key) => {
        window.sessionStorage.removeItem(key);
      });
    },
    savePageState() {
      window.sessionStorage.setItem(
        PAGE_STATE_KEY,
        JSON.stringify({
          attendanceTabIndex: this.attendanceTabIndex,
        }),
      );
    },
    restorePageState() {
      const raw = window.sessionStorage.getItem(PAGE_STATE_KEY);
      if (!raw) return;
      try {
        const state = JSON.parse(raw);
        if (state && typeof state.attendanceTabIndex === "number") {
          this.attendanceTabIndex = state.attendanceTabIndex;
        }
      } catch (e) {
        window.sessionStorage.removeItem(PAGE_STATE_KEY);
      }
    },
    refreshCurrentTab() {
      const panel = this.$refs.currentTabPanel;
      if (panel && typeof panel.refreshByTabSwitch === "function") {
        panel.refreshByTabSwitch();
      }
    },
    getTabIndexByKey(tabKey) {
      return this.attendanceTabs.findIndex((tab) => tab.key === tabKey);
    },
    hasVisitedTab(tabKey) {
      return this.visitedTabKeys.includes(tabKey);
    },
    markTabVisited(tabKey) {
      if (tabKey && !this.hasVisitedTab(tabKey)) {
        this.visitedTabKeys.push(tabKey);
      }
    },
    handleTabChange(item) {
      const nextTabKey = item && item.key;
      const nextIndex = this.getTabIndexByKey(nextTabKey);
      if (nextIndex < 0 || nextIndex === this.attendanceTabIndex) {
        return;
      }
      this.attendanceTabIndex = nextIndex;
      this.savePageState();
      if (!this.hasVisitedTab(nextTabKey)) {
        this.markTabVisited(nextTabKey);
        return;
      }
      this.$nextTick(() => {
        this.refreshCurrentTab();
      });
    },
  },
};
</script>
